export function stickyHeader() {
    function stickyHeader() {
        let $header = $(".header");
        let top = $(document).scrollTop();
        if (top > 0) {
            $header.addClass("scrolled");
        } else {
            $header.removeClass("scrolled");
        }
    }

    window.addEventListener("load", () => {
        stickyHeader();
    });
    window.addEventListener("scroll", () => {
        stickyHeader();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/stickyHeader.js